import React from "react";
import { GridColumn, GridRow, GridContainer } from "arv-reactcomponents";
import ListElement from "./ListElement";
import { CORPORATE_GIFTING_COMPONENTS } from "npmlinks-constants";

const getList = () => {
  const detailsObj = JSON.parse(
    CORPORATE_GIFTING_COMPONENTS.GIFTING_DETAILS_LIST,
  );
  const detailsArray = detailsObj.lists;
  return (
    <div>
      {detailsArray.map(object => (
        <ListElement data={object} />
      ))}
    </div>
  );
};

const GifitingDetails = () => (
  <GridContainer>
    <GridRow className="wc-giftingdetails-container">
      <GridColumn className="wc-giftingdetails-subcontainer">
        <h3 className="wc-giftingdetails-subtitle">
          {CORPORATE_GIFTING_COMPONENTS.GIFTING_DETAILS_SUBTILE}
        </h3>
        <div className="wc-giftingdetails-brief">
          {CORPORATE_GIFTING_COMPONENTS.GIFTING_DETAILS_BRIEF}
        </div>
        <h3 className="wc-giftingdetails-subtitle">
          {CORPORATE_GIFTING_COMPONENTS.GIFTING_DETAILS_BANDWIDTH_SUBTILE}
        </h3>
        {getList()}
        <div className="wc-giftingdetails-conclusion">
          {CORPORATE_GIFTING_COMPONENTS.GIFTING_DETAILS_CONCLUSION}
        </div>
        <div />
      </GridColumn>
    </GridRow>
  </GridContainer>
);

export default GifitingDetails;